export default "__VITE_ASSET__d5d7d6d9__"